module.exports = __webpack_public_path__ + "static/xuanyuanjian7-dcc2f904e24e43a7ac8cb215d1801bbc.png";